import { NgModule } from '@angular/core';
import { TabsComponent } from './tabs.component';
import { TabComponent } from './tab.component';
import {BrowserModule} from '@angular/platform-browser';

@NgModule({
    imports: [
        BrowserModule
    ],
    exports: [
        TabComponent,
        TabsComponent
    ],
    declarations: [
        TabComponent,
        TabsComponent
    ],
})
export class BzTabModule {}
